// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__6X7_m","newChip":"styles_newChip__ijTaU"};